module.exports = __webpack_public_path__ + "static/fonts/Acumin-BdItPro.53bea63.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Acumin-BdItPro.woff
// module id = Yab7
// module chunks = 1